import React, { useState } from 'react'
import { useEffect } from 'react';
import { FocusScope } from '@react-aria/focus';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import useOutsideClicked from './useOutsideClicked';

function CustomSelect({ options, setValue, register, dropdownButtonRef }) {
    const { t } = useTranslation();
    const wrapperRef = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const close = () => setOpen(false);
    const toggleDropdown = () => setOpen(!isOpen)
    const [selectedItem, setSelectedItem] = useState(null);
    useOutsideClicked(wrapperRef, dropdownButtonRef, close);

    const handleItemClick = (value , e) => {
        selectedItem == value ? setSelectedItem(null) : setSelectedItem(value);
    }

    const handleKeyPress = (e) => {
        if(e.keyCode === 13){
            toggleDropdown();
        }
        if(e.keyCode === 27){
            close();
        }
    }

    const handleEsc = (e) => {
        if (e.keyCode === 27) {
            setOpen(false);
        }
    }

    useEffect(() => {
        setSelectedItem(null);
    }, [options])

    useEffect(() => {
        setValue('gifteeTime', selectedItem);
    }, [selectedItem])

    return (
        <div ref={wrapperRef}>
            <div ref={dropdownButtonRef} tabIndex={0} className='dropdown' onClick={toggleDropdown} onKeyDown={e => handleKeyPress(e)}
                {...register("gifteeTime", {
                    required: t("Required"),
                })}
            >
                <div className={`dropdown-header ${isOpen ? 'open' : ''}`}>
                    {selectedItem ? options.find(item => item.value == selectedItem)?.value : "בחר שעה"}
                </div>

                <FocusScope contain restoreFocus autoFocus>
                    <div role="dialog" className={`dropdown-body ${isOpen ? 'open' : ''}`} onKeyDown={e => handleEsc(e)}>
                        {options.map((item , idx) => (
                            <button key={idx} type="button" className={`dropdown-item ${selectedItem == item.value ? 'selected' : ''}`} onClick={e => handleItemClick(item.value)} id={item.value}>
                                {item.value}
                            </button>
                        ))}
                    </div>
                </FocusScope>
            </div>
        </div>
    )
}

export default CustomSelect
